module.exports = __webpack_public_path__ + "static/img/wlt1350bb.9ff76b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wlt1350bb.jpg
// module id = BCns
// module chunks = 0